<template>
    <v-select
        class="search-customer-form"
        :placeholder="placeholder"
        :filterable="false"
        :filter="fuseSearchFilter"
        :getOptionLabel="option => option.name"
        :options="customers"
        @search="onSearch"
        @input="onSearchInput">
        <div slot="no-options">
            <template v-if="search">
                Aucun client ne correspond à votre recherche
            </template>
            <template v-else>
                {{ placeholder }}
            </template>
        </div>
        <template #option="item">
            {{ item.type_label }} <span v-if="item.deleted_at" class="text-muted">(archivé)</span>
            <br>
            {{ item.name }}
        </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select';
import {usePostRequest} from "./compositions/axios/postRequest";
import Fuse from "fuse.js"

export default {
    name: "AdminSearchCustomerForm",

    components: {
        vSelect,
    },

    setup() {
        const {
            loading: sending,
            errors,
            post
        } = usePostRequest();

        return {
            sending,
            errors,
            post
        };
    },

    data: function () {
        return {
            customers: [],
            search: null,
        };
    },

    props: {
        placeholder: {
            type: String,
            required: true,
        },
        searchArchived: {
            type: Number|Boolean,
            required: false,
            default: false,
        },
    },

    methods: {
        onSearch(search, loading) {
            loading(true);
            this.search = search;
            this.doSearch(loading, search);
        },

        async doSearch(loading, search) {
            this.customers = [];
            if (search) {
                try {
                    const archived = this.searchArchived ? 1 : 0;
                    const data = await this.post(`/espace-admin/clients/recherche/json?archived=${archived}`, {
                        search: search
                    });
                    if (data) {
                        this.customers = data.customers.map(function (item, index) {
                            return {
                                index,
                                ...item,
                            }
                        });
                    }
                } catch (e) {
                    console.error(e)
                }
            }
            loading(false);
        },

        onSearchInput(itemSelected) {
            this.$emit('selected', itemSelected);

            window.location = '/espace-admin/clients/' + itemSelected.id + '/modifier';
        },

        fuseSearchFilter(options, search) {
            const fuse = new Fuse(options, {
                keys: ['name'],
                shouldSort: true,
                includeScore: true,
            });
            let fuseList = search.length ? fuse.search(search) : fuse.list;
            let filtered = [];
            for (const key in fuseList) {
                filtered.push(fuseList[key].item);
            }
            return filtered;
        },
    },
}
</script>
